export default "images/hydration.png";